module.exports = __webpack_public_path__ + "static/scale-model-of-tony-curtis'-star-in-glendale-california-4f87aee8d610697d355c0a2cb3ceca4f.png";